import {
  useSearchQueryFilter,
  useSearchTypeFromRoute,
  useTrackEvents,
} from '@aibees/elephant/hooks';
import { DropDown } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import { TimeFrames, type TimeFrameSelectProps as Props } from './types';

export const FRAME_LABELS = {
  [TimeFrames.UNDEFINED]: '',
  [TimeFrames.SIX]: '6',
  [TimeFrames.THREE]: '3',
  [TimeFrames.TWELVE]: '12',
  [TimeFrames.TWENTY_FOUR]: '24',
};

export const TimeFrameSelect = memo(
  ({ className, onChange, value, filter }: Props) => {
    const { setParam } = useSearchQueryFilter({
      select: [filter.field!],
    });
    const searchType = useSearchTypeFromRoute();
    const { track } = useTrackEvents();

    const handleSelect = (v: TimeFrames) => {
      if (filter.field) {
        // todo: as we just using this filter in headcount-growth, we don't need to setParam, but maybe in the future we will need to setParam
        // setParam(filter.field, event.target.value);
        track('FILTER', {
          filterName: filter.field,
          filterType: filter.type,
          filterValue: v,
          searchType,
        });
      }
      // setSelectedTimeFrame(event.target.value as TimeFrames);
      onChange?.(v);
    };

    return (
      <Box
        display="flex"
        alignItems="center"
        className={classnames('TimeFrameSelect', className)}
        sx={SX.root}
      >
        <DropDown
          options={Object.keys(TimeFrames)
            .filter((i) => i !== TimeFrames.UNDEFINED)
            .map((i) => ({
              key: i,
              label: FRAME_LABELS[i as TimeFrames],
              value: i as TimeFrames,
            }))}
          value={value ?? TimeFrames.UNDEFINED}
          onChange={handleSelect}
          size="small"
          fullWidth
        />
      </Box>
    );
  }
);

TimeFrameSelect.displayName = 'TimeFrameSelect';
